import { Component } from '@angular/core';
import { AddressService } from 'src/service/address.service';


import { Subscription } from 'rxjs';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { AlertController, ModalController, Platform, ToastController } from '@ionic/angular';
import { ModelService } from './model.service';
import { LoginPage } from './auth/login/login.page';
import { ProfileService } from 'src/service/profile.service';
import { CachingService } from './caching.service';
import { WsAPiService } from './ws-api.service';
import { DatapassService } from 'src/service/datapass.service';
import { LoadingService } from './loading.service';
import { FbmessagingService } from './fbmessaging.service';

export let browserRefresh = false;
declare let cordova: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  subscription: Subscription;

  constructor(public model: ModelService,
    public activeRoute:ActivatedRoute,

    public dot: DatapassService,
    public modalcontroler: ModalController,
    private addressService: AddressService,
    public rout: Router,
    public fb:FbmessagingService,
    public ws: WsAPiService,
    public loadingservice:LoadingService,
    public caching: CachingService,
    public profile: ProfileService,
    public platform: Platform,
    private alt: AlertController) {


      // disable browser back button
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = function () {
          window.history.go(1);
      };


      this.checkVendingURL();

    // this.platform.ready().then(() => {
    //   if (this.platform.is('cordova')) {
    //     console.log("cordova");

    //     cordova.plugins.diagnostic.isGpsLocationEnabled(function (enabled) {
    //       // this.alert("GPS location is " + (enabled ? "enabled" : "disabled"));
    //       if(!enabled){
    //         this.alert('ກະລຸນາເປີດ GPS ໂທລະສັບຂອງທ່ານກ່ອນ !');
    //       }
    //     }, function (error) {
    //       alert("The following error occurred: " + error);
    //     });

    //   } else {
    //     console.log('web');

    //   }
    // })

    // this.ws.storeacceptedSubscription.subscribe(r => {
    //   console.log('neworder', r);
    //   if (!r) return;
    //   this.loadingservice.ontoast('ຮ້ານຕອບກັບອໍເດີ້ຂອງທ່ານແລ້ວ', 3000);
    //   this.dot.dot=true
    //   // if (this.orderstatus == 'new') {
    //   //   this.skip['new'] = 0;
    //   //   this.order_list['new'] = [];
    //   //   this.showorder = [];
    //   //   this.loadOrder();
    //   // }
    // })


    this.subscription = rout.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !rout.navigated;
      }
    });
    this.addressService.initAddresses();

    // this.dot.dot = true;

  }




  public selectedIndex = 0;
  public appPages = [
    {
      title: 'ໜ້າຫຼັກ',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'ຂ່າວສານ',
      url: '/news',
      icon: 'newspaper'
    },
    // {
    //   title: 'ປະເພດສິນຄ້າ',
    //   url: '/category',
    //   icon: 'list'
    // },
    {
      title: 'ຮ້ານຄ້າ',
      url: '/store-list',
      icon: 'storefront'
    },
    {
      title: 'ກະຕ່າຂອງຂ້ອຍ',
      url: '/cart',
      icon: 'cart'
    },
    {
      title: 'ສິນຄ້າທີ່ຖືກໃຈ',
      url: '/myfavoritepost',
      icon: 'heart'
    },
    // {
    //   title: 'ກະເປົາເງິນ',
    //   url: '/mywallet',
    //   icon: 'card'
    // },
    {
      title: 'ລາຍການຊື້ຂອງຂ້ອຍ',
      url: '/orderlist',
      icon: 'receipt'
    },
    {
      title: 'ຂໍ້ມູນສ່ວນຕົວ',
      url: '/user/profile',
      icon: 'person'
    },
    {
      title: 'privacy',
      url: '/privacy',
      icon: 'shield'
    },
    // {
    //   title: 'ກ່ຽວກັບເຮົາ',
    //   url: '/about',
    //   icon: 'information-circle'
    // },
    // {
    //   title: 'ຕິດຕໍ່ເຮົາ',
    //   url: '/contactus',
    //   icon: 'mail'
    // }

  ];


  async logout() {
    const alert = await this.alt.create({
      // cssClass: 'my-custom-class',
      header: 'ຢືນຢັນ',
      backdropDismiss: false,
      message: 'ຕ້ອງການອອກຈາກລະບົບ ?',
      buttons: [
        {
          text: 'ຍົກເລີກ',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
          }
        }, {
          text: 'ຕົກລົງ',
          handler: () => {
            this.model.presentToast();
            this.selectedIndex=0;
            this.rout.navigate(['home'])
            localStorage.removeItem('token');
            // localStorage.setItem('token', null);

            localStorage.removeItem('profile');

            this.ws.loggoutWS();

            const sub=localStorage.getItem('fcmsubs');
            if(sub!=null && sub!=undefined && sub!='[]'){

              this.fb.fcmUnSub(JSON.parse(sub)).then(r=>{
                this.fb.clearSub();
              });

            }
          }
        }
      ]
    });

    await alert.present();
  }


  async getrout(url: string) {

    console.log(url);

    if (url == '/user/profile' || url == '/orderlist') {
      if (!localStorage.getItem('token')) {
        const alert = await this.alt.create({
          // cssClass: 'my-custom-class',
          header: 'ຢືນຢັນ',
          backdropDismiss: false,
          message: 'ຕ້ອງການລັອກອິນເພື່ອສືບຕໍ່ບໍ່ ?',
          buttons: [
            {
              text: 'ຍົກເລີກ',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
              }
            }, {
              text: 'ຕົກລົງ',
              handler: async () => {
                const modal = await this.modalcontroler.create({
                  component: LoginPage,
                  componentProps: {
                    'modal': true
                  }
                });

                modal.onDidDismiss().then(res => {

                  if (res.data.reload) {
                    
                    if(this.dot.isHomePage == true){
                      this.loadaddress();
                    }else{

                      this.rout.navigateByUrl('home');
                    }

                  }
                })
                return modal.present();
              }
            }
          ]
        });
        await alert.present();
      } else {
        this.rout.navigateByUrl(url);
      }
    } else {
      this.rout.navigateByUrl(url);
    }
  }
  checktoken() {
    if (localStorage.getItem('token') != null && localStorage.getItem('token') != undefined) {

      return true;
    } else {

      return false
    }
  }

  //=========================== address ===================================
  async loadaddress(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      localStorage.setItem('skip', '0')

      this.profile.LoadAddress().subscribe(async res => {
        console.log('res of address', res);

        if (res.data.count != 0) {
          localStorage.setItem('profile', JSON.stringify(res.data.rows));
        }

        if (res.data.count == 0) {

          this.create_profile().then(r => {
            console.log("Create!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!", r);

            this.profile.LoadAddress().subscribe(rx => {
              console.log("load ADDRESS !!!!!!!!!!!!", rx);

              if (rx.status == 1) {
                localStorage.setItem('profile', JSON.stringify(rx.data.rows));
              }
              resolve(true)
            })
          }).catch(e => {
            console.log(e);
            reject(e)
          })
        } else {
          resolve(true)
        }

      }), errr => {
        console.log('error', errr);
        reject(errr)
      };
    })
  }

  async create_profile(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let data_of_address = {
        // storeUuid: localStorage.getItem('token')
        storeUuid: ''
      }
      this.profile.new_address(data_of_address).subscribe(async res => {
        if (res.status == 1) {
          console.log("res of new address", res);
          resolve(res)
        } else {
          console.log('status of new address', res);

          reject(new Error(res.message));
        }
      }, async error => {
        console.log('add address errror', error);
        reject(error);
      })
    });

  }


  checkVendingURL(){
    const url_string = window.location.href
    let url = new URL(url_string);
    let vending = url.searchParams.get("vending");
    console.log(vending);
    if(vending == 'true'){
      // http://localhost:8101/home?vending=true
      localStorage.setItem('isvending','true');
      this.dot.isvending = true;
    }else if(vending == 'false'){
      localStorage.removeItem('isvending');
      this.dot.isvending = false;
    }
  }
}
